<template>
  <div id="app">
    <div id="nav">
      <NavBar/>
    </div>
    <router-view />
  </div>
</template>

<script>

import NavBar from '@/components/NavBar.vue'

export default {
  components: {
    NavBar
  },
  mounted: function () {
    // Initiate fetch of data
    this.$store.dispatch('combined/getData')
    // Listen for pwa install prompt
    this.$store.dispatch('pwa/listenForPrompt')
  }
}

</script>

<style lang="scss">
@import 'variables';
@import "~bootstrap/scss/bootstrap";

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.blue-background {
  background-color: $mapbox-sea-blue;
  padding-top: 20px;
  padding-bottom: 20px;
  overflow-y: auto;
  position:absolute;
  width:100%;
  top: 56px;
  bottom:0;
  left:0;
}

.jumbotron {
  margin-bottom: 0;
  padding-bottom: 1rem;
}

body {
  margin: 0;
}
</style>
